import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translation files
import en from './locales/en.json';
import zh from './locales/zh.json';
import cn from './locales/cn.json';

const resources = {
  en: {
    translation: en,
  },
  zh: {
    translation: zh,
  },
  cn: {
    translation: cn,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    debug: process.env.NODE_ENV === 'development',

    interpolation: {
      escapeValue: false, // React already does escaping
    },

    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
      // Map browser language codes to our application language codes
      convertDetectedLanguage: (lng: string) => {
        // Map browser language codes to our app language codes
        if (lng.startsWith('zh-CN') || lng.startsWith('zh-Hans')) {
          return 'cn'; // Simplified Chinese
        }
        if (lng.startsWith('zh-TW') || lng.startsWith('zh-HK') || lng.startsWith('zh-Hant')) {
          return 'zh'; // Traditional Chinese
        }
        if (lng.startsWith('zh')) {
          // Default zh to Traditional Chinese (zh) for Hong Kong context
          return 'zh';
        }
        return lng;
      },
    },
  });

export default i18n; 